/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Media_Type_DocInputs */

const en_media_type_doc = /** @type {(inputs: Media_Type_DocInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Portable Doc`)
};

const id_media_type_doc = /** @type {(inputs: Media_Type_DocInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dokumen Portabel`)
};

/** @type {(inputs: Media_Type_DocInputs) => LocalizedString} */
const es_media_type_doc = en_media_type_doc;

/** @type {(inputs: Media_Type_DocInputs) => LocalizedString} */
const fr_media_type_doc = en_media_type_doc;

/** @type {(inputs: Media_Type_DocInputs) => LocalizedString} */
const de_media_type_doc = en_media_type_doc;

/** @type {(inputs: Media_Type_DocInputs) => LocalizedString} */
const ja_media_type_doc = en_media_type_doc;

/** @type {(inputs: Media_Type_DocInputs) => LocalizedString} */
const zh_media_type_doc = en_media_type_doc;

/** @type {(inputs: Media_Type_DocInputs) => LocalizedString} */
const ar_media_type_doc = en_media_type_doc;

/** @type {(inputs: Media_Type_DocInputs) => LocalizedString} */
const it_media_type_doc = en_media_type_doc;

/** @type {(inputs: Media_Type_DocInputs) => LocalizedString} */
const ru_media_type_doc = en_media_type_doc;

/** @type {(inputs: Media_Type_DocInputs) => LocalizedString} */
const pt_media_type_doc = en_media_type_doc;

/** @type {(inputs: Media_Type_DocInputs) => LocalizedString} */
const ko_media_type_doc = en_media_type_doc;

/**
* | output |
* | --- |
* | "Portable Doc" |
*
* @param {Media_Type_DocInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const media_type_doc = /** @type {((inputs?: Media_Type_DocInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Type_DocInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_media_type_doc(inputs)
	if (locale === "es") return es_media_type_doc(inputs)
	if (locale === "fr") return fr_media_type_doc(inputs)
	if (locale === "de") return de_media_type_doc(inputs)
	if (locale === "ja") return ja_media_type_doc(inputs)
	if (locale === "zh") return zh_media_type_doc(inputs)
	if (locale === "ar") return ar_media_type_doc(inputs)
	if (locale === "id") return id_media_type_doc(inputs)
	if (locale === "it") return it_media_type_doc(inputs)
	if (locale === "ru") return ru_media_type_doc(inputs)
	if (locale === "pt") return pt_media_type_doc(inputs)
	return ko_media_type_doc(inputs)
});